// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"67":"7f0c75c1","80":"d0447323","245":"component---src-pages-index-tsx","379":"1bfc9850","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"67":"e8ad89e91176c9e84bda","80":"4369bba8080d93dc7612","245":"a391136dfa5577240b44","379":"5a37e75385ec3f954feb","453":"1ee93ed8327295f61c5e"}[chunkId] + ".js";
};